<template>
  <project-template title="配置纳排标准" nextBtnText="下一步：完成配置" @lastClick="lastClick"
    @nextClick="nextClick">
    <template v-slot:leftContent>
      <div class="box box1">
        <ul class="ul1">
          <li></li>
          <li class="item">
            <in-hospital></in-hospital>
          </li>
          <li class="item">
            <arrow-right></arrow-right>
          </li>
          <li class="item">
            <filter-qualifications></filter-qualifications>
          </li>
          <li class="item">
            <arrow-right></arrow-right>
          </li>
          <li class="item">
            <EDC-system></EDC-system>
          </li>
          <li class="item">
            <arrow-right></arrow-right>
          </li>
          <li class="item">
            <face-talk></face-talk>
          </li>
          <li></li>
        </ul>
        <ul class="ul2">
          <li>病人入院</li>
          <li>筛选资格</li>
          <li>EDC系统</li>
          <li>面对面访谈</li>
        </ul>
      </div>
      <div class="down-arrow-row">
        <arrow-down width="30px"></arrow-down>
      </div>
      <template v-for="(period, index) in periodItemList">
        <div class="box box2" style="color: white;">
          <div>
            <label class="project-template5-title">
              {{ period.name }}
            </label>
            <a-tag color="green" v-if="period.base != '1'">
              距基点{{ period.basePointDay }}天
            </a-tag>
          </div>
          <table class="table">
            <tbody>
              <tr>
                <td style="width: 20%;">
                  <div>
                    <custom-form></custom-form>
                    <br>
                    <span>表单</span>
                  </div>
                </td>
                <td style="width: 80%">
                  <div class="form-row" v-for="(form, index) in normalFormList(period)" :key="index">
                    {{ form.name }}
                  </div>
                </td>
              </tr>
              <tr>
                <td style="padding: 15px 0">
                  <div>
                    <survey-table></survey-table>
                    <br>
                    <span>量表</span>
                  </div>
                </td>
                <td>
                  <div class="form-row " v-for="(form, index) in scaleFormList(period)" :key="index">
                    {{ form.name }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="down-arrow-row" v-if="index < periodItemList.length - 1">
          <arrow-down width="30px"></arrow-down>
        </div>
      </template>
    </template>
    <template v-slot:rightContent>
      <filtrate-pad :projectId="project.projectId"></filtrate-pad>
    </template>
  </project-template>
</template>

<script>
import Disease from '@views/apppad/projectTemplate/projectTemplate2/Disease'
import Dept from '@views/apppad/projectTemplate/projectTemplate2/Dept'
import { getAction } from '@api/manage'
import FiltratePad from '@views/project/components/FiltratePad'
import InHospital from '@comp/Icon/InHospital'
import FilterQualifications from '@comp/Icon/FilterQualifications'
import EDCSystem from '@comp/Icon/EDCSystem'
import FaceTalk from '@comp/Icon/FaceTalk'
import ArrowRight from '@comp/Icon/ArrowRight'
import ArrowDown from '@comp/Icon/ArrowDown'
import CustomForm from '@comp/Icon/CustomForm'
import SurveyTable from '@comp/Icon/SurveyTable'
import ProjectTemplate from '@comp/pad/ProjectTemplate'
export default {
  name: 'ProjectTemplate5',
  components: {
    FiltratePad,
    Dept,
    Disease,
    InHospital,
    FilterQualifications,
    EDCSystem,
    FaceTalk,
    ArrowRight,
    ArrowDown,
    CustomForm,
    SurveyTable,
    ProjectTemplate
  },
  data() {
    return {
      project: {},
      periodItemList: [],
      url: {
        listUrl: '/projectconfigview/filtrate/list',
        deleteUrl: '/projectconfigview/filtrate/delete',
        saveUrl: '/projectconfigview/filtrate/saveOrUpdate'
      }
    }
  },
  computed: {

  },
  mounted() {
    this.loadProjectData()
  },
  methods: {
    getFormList(moduleList) {
      const formList = []      
      moduleList.forEach(module => {
        if (module.checkedFormList) {
          module.checkedFormList.forEach(form => {
            formList.push(form)
          })
        }
      })
      return formList
    },
    normalFormList(period) {
      const result = []
      const moduleObject = JSON.parse(this.project.moduleJson)
      for (let key in moduleObject){
          this.getFormList(moduleObject[key]).forEach(form => {
          if (form.scale != '1') {
            if(period.sourceFormIdList.indexOf(form.id) !== -1){
              result.push(form)
            }            
          }
        })
      }
      
      return result
    },
    scaleFormList(period) {
      const result = []
      const moduleObject = JSON.parse(this.project.moduleJson)
      for (let key in moduleObject){
          this.getFormList(moduleObject[key]).forEach(form => {
          if (form.scale == '1') {
            if(period.sourceFormIdList.indexOf(form.id) !== -1){
              result.push(form)
            }
          }
        })
      }
      
      return result
    },
    loadProjectData() {
      const id = this.$route.query.id
      getAction('/projectconfigview/configProject/queryById', { id: id }).then(res => {
        if (res.success) {
          this.project = res.result

          this.loadPeriodItemData()
        }
      })
    },
    loadPeriodItemData() {
      const id = this.$route.query.id
      getAction('/projectconfigview/periodItem/listAll', { projectId: id }).then(res => {
        if (res.success) {
          this.periodItemList = res.result
        }
      })
    },
    nextClick() {
      this.$emit('next')
    },
    lastClick() {
      this.$emit('last')
    }
  }
}
</script>

<style scoped lang="less">
.project-template {
  .down-arrow-row {
    text-align: center;
    padding: 10px 0;
  }

  .form-row {
    padding: 5px 15px;
  }

  .project-template5-title {
    font-size: 18px;
    text-align: center;
    padding-left: 20px;
  }
}

.box {
  background: rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  border: 1px solid white;
  // border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
  overflow: hidden;
}

.box1 {
  padding: 12px 0;

  .ul1 {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: auto 24px 58px 24px 58px 24px 58px 24px auto;

    .item {
      text-align: center;

      span {
        display: block;
        font-weight: 400;
        font-size: 12px;
        color: white;
        line-height: 14px;
        margin-top: 5px;
      }
    }
  }

  .ul2 {
    list-style: none;
    margin: 10px 0 0;
    padding: 0;
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;

    li {
      font-size: 12px;
      color: white;
      text-align: center;
    }
  }

}

.box2 {
  padding: 20px 0;
}

.table {
  width: 90%;
  margin: 0 auto;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  border: solid 1px #77797E;
  background: #4d4e5a;
  margin-top: 15px;

  td {
    font-size: 12px;
    border-right: 1px solid #77797E;
    padding: 15px 0;
    text-align: center;
  }

  td {
    border-top: 1px solid #77797E;
  }

  td:last-child {
    border-right-color: transparent;
    text-align: left;
  }

  tr:first-child td {
    border-top-color: transparent;
  }
}
</style>
